import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { getRedirectResult, onAuthStateChanged } from 'firebase/auth';

@Injectable({ providedIn: 'root' })
export class AuthBootstrapService {
  constructor(private auth: Auth) { }

  async init(): Promise<void> {
    const protocol = window.location.protocol;
    const isWeb = protocol === 'http:' || protocol === 'https:';

    if (isWeb) {
      await new Promise<void>((resolve) => {
        const unsub = onAuthStateChanged(this.auth, () => {
          unsub();
          resolve();
        });
      });
    } else {
      return;
    }
  }
}